/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Color_By_Reason_No_GpsInputs */

const en_ui_color_by_reason_no_gps = /** @type {(inputs: Ui_Color_By_Reason_No_GpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No GPS data`)
};

const de_ui_color_by_reason_no_gps = /** @type {(inputs: Ui_Color_By_Reason_No_GpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine GPS-Daten`)
};

/**
* | output |
* | --- |
* | "No GPS data" |
*
* @param {Ui_Color_By_Reason_No_GpsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_color_by_reason_no_gps = /** @type {((inputs?: Ui_Color_By_Reason_No_GpsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Color_By_Reason_No_GpsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_color_by_reason_no_gps(inputs)
	return de_ui_color_by_reason_no_gps(inputs)
});